import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appErrorTooltip]'
})
export class ErrorTooltipDirective {
  private errormsg;
  generateErrorElem;
  nativeElem ;

  constructor(private el: ElementRef) {
    this.nativeElem = el.nativeElement;
    this.nativeElem.addEventListener('focus', () => {
      this.errormsg = this.nativeElem.getAttribute('errormsg');
      if(this.errormsg && this.errormsg !== 'false') {
        this.generateErrorElem = this.generateErrorElement();
        this.nativeElem.parentElement.appendChild(this.generateErrorElem);
      }
    });
    this.nativeElem.addEventListener('focusout', () => {
      if (this.generateErrorElem) {
        if (this.generateErrorElem.remove) {
          this.generateErrorElem.remove();
        }else {
          this.generateErrorElem.parentNode.removeChild(this.generateErrorElem);
        }
      }
      this.errormsg = false;
    });
  }


  /**
   *
   * @return {HTMLElementTagNameMap[string]}
   * return this html
   *<div class="errorTooltip" *ngIf="errormsg">
        <span>{{errormsg}}</span>
    </div>
   */
  generateErrorElement() {
    let div = document.createElement('div');
    div.className += 'errorTooltip';
    let span = document.createElement('span');
    span.innerText = this.errormsg;
    div.appendChild(span);
    return div;
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/shared/error-tooltip/error-tooltip.directive.ts